import { useEffect, useState } from "react";
import { ThreeDots } from "react-loader-spinner";
import cancelImage from "../assets/images/cancel.png";
import editImage from "../assets/images/edit.png";
import exitImage from "../assets/images/exit.png";
import saveImage from "../assets/images/save.png";
import { useDeleteInCompletedTodoMutation, useToggleTodoStatusMutation, useUpdateTodoMutation } from "../features/api/apiSlice";

export default function Todo({ todo }) {
    const { text, id, completed, color } = todo;

    const [handleDeleteTodo, { isLoading: deleteLoading }] = useDeleteInCompletedTodoMutation();
    const [handleUpdateTodo, { isLoading: updateLoading, isSuccess: updateSuccess }] = useUpdateTodoMutation();
    const [handleToggleStatus, { isLoading: toggleLoading }] = useToggleTodoStatusMutation();
    console.log("file: Todo.js ~ line 15 ~ toggleLoading", toggleLoading)

    const [editing, setEditing] = useState(false);
    const [inputValue, setInputValue] = useState("");



    const handleStatusChange = () => {
        !toggleLoading && handleToggleStatus({ id: todo.id, body: { ...todo, completed: !completed } })
    };

    const handleColorChange = (selectedColor) => {
        let newColor = selectedColor;
        if (color === selectedColor) {
            newColor = "";
        }
        handleUpdateTodo({ id: todo.id, body: { ...todo, color: newColor } })
    };

    const handleDelete = () => {
        handleDeleteTodo(id);
    };

    const handleEdit = () => {
        setEditing(true);
        setInputValue(text)
    }
    const handleSave = (e) => {
        e.preventDefault();
        handleUpdateTodo({ id: todo.id, body: { ...todo, text: inputValue } })

    };

    useEffect(() => {
        if (updateSuccess) setEditing(false);
    }, [updateSuccess])


    return (
        <div className="flex justify-start items-center p-2 hover:bg-gray-100 hover:transition-all space-x-4 border-b border-gray-400/20 last:border-0">
            <div
                className={`relative rounded-full bg-white border-2 border-gray-400 w-5 h-5 flex flex-shrink-0 justify-center items-center mr-2 ${completed &&
                    "border-green-500 focus-within:border-green-500"
                    }`}
            >
                <input
                    type="checkbox"
                    checked={completed}
                    onChange={() => handleStatusChange(id)}
                    className="opacity-0 absolute rounded-full cursor-pointer"
                />
                {completed && (
                    <svg
                        className="fill-current w-3 h-3 text-green-500 pointer-events-none"
                        viewBox="0 0 20 20"
                    >
                        <path d="M0 11l2-2 5 5L18 3l2 2L7 18z" />
                    </svg>
                )}
            </div>

            <div
                className={`select-none flex-1 ${completed && "line-through"}`}
            >
                {
                    editing ? <form onSubmit={e => handleSave(e)}>
                        <input style={{}} onChange={(e) => setInputValue(e.target.value)} value={inputValue} />
                    </form> : <span onClick={handleEdit}>{text}</span>
                }
            </div>
            {
                editing ? updateLoading ? <ThreeDots
                    height="20"
                    width="20"
                    radius="9"
                    color="red"
                    ariaLabel="three-dots-loading"
                    visible={true}
                /> : <>
                    <img
                        src={saveImage}
                        className="flex-shrink-0 w-4 h-4 ml-2 cursor-pointer"
                        alt="Cancel"
                        onClick={handleSave}
                    />
                    <img
                        src={exitImage}
                        className="flex-shrink-0 w-4 h-4 ml-2 cursor-pointer"
                        alt="Cancel"
                        onClick={() => setEditing(false)}
                    />
                </> : (deleteLoading || updateLoading || toggleLoading) ? <ThreeDots
                    height="20"
                    width="20"
                    radius="9"
                    color="red"
                    ariaLabel="three-dots-loading"
                    visible={true}
                /> : <>
                    <div
                        className={`flex-shrink-0 h-4 w-4 rounded-full border-2 ml-auto cursor-pointer hover:bg-green-500 border-green-500 ${color === "green" && "bg-green-500"
                            }`}
                        onClick={() => handleColorChange("green")}
                    ></div>

                    <div
                        className={`flex-shrink-0 h-4 w-4 rounded-full border-2 ml-auto cursor-pointer hover:bg-yellow-500 border-yellow-500 ${color === "yellow" && "bg-yellow-500"
                            }`}
                        onClick={() => handleColorChange("yellow")}
                    ></div>

                    <div
                        className={`flex-shrink-0 h-4 w-4 rounded-full border-2 ml-auto cursor-pointer hover:bg-red-500 border-red-500 ${color === "red" && "bg-red-500"
                            }`}
                        onClick={() => handleColorChange("red")}
                    ></div>

                    <img
                        src={editImage}
                        className="flex-shrink-0 w-4 h-4 ml-2 cursor-pointer"
                        alt="Cancel"
                        onClick={handleEdit}
                    />
                    <img
                        src={cancelImage}
                        className="flex-shrink-0 w-4 h-4 ml-2 cursor-pointer"
                        alt="Cancel"
                        onClick={handleDelete}
                    />
                </>
            }

        </div>
    );
}
